import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'
import NotificationModel from '@/views/Notification/models/notification'
import NotificationResourceModel from '@/views/Notification/models/notificationResource'
import moment from 'moment'

export default class NotificationGroupModel extends JsonApiObject {
    public constructor(data: any, included?) {
        super(data, included)
    }

    numNotifications
    canMarkAllAsRead

    get project() {
        return this._relationships['project'] ? this._relationships['project'] : null
    }

    get resource(): NotificationResourceModel {
        return this._relationships['resource'] ? this._relationships['resource'] : null
    }

    get topNotifications(): Array<NotificationModel> {
        return this._relationships['topNotifications']
            ? this._relationships['topNotifications']
            : []
    }

    set topNotifications(notifications: Array<NotificationModel>) {
        this._relationships['topNotifications'] = notifications
    }

    get leTime() {
        return this.topNotifications.length > 0
            ? this.topNotifications[this.topNotifications.length - 1].time
            : moment(new Date()).toISOString(true)
    }

    get leReadAt() {
        return this.topNotifications.length > 0
            ? this.topNotifications[this.topNotifications.length - 1].readAt
            : moment(new Date()).toISOString(true)
    }

    async markAllAsRead() {
        let res = await Vue.prototype.$vbit.post(
            'notification',
            `notificationGroups/${this._id}/markAllAsRead`
        )
        return res
    }

    static async search(query) {
        let res = await Vue.prototype.$vbit.get('notification', 'notificationGroups', query)

        return res.data.map((item) => new NotificationGroupModel(item, res.included))
    }
}
function iso8601() {
    throw new Error('Function not implemented.')
}
